import { Injectable } from '@angular/core';
import { IDataSerializer } from '../../../core/interfaces';
import { IQuoteItemPointsListConfiguration } from '../../points-schedule/models';

@Injectable({
  providedIn: 'root',
})
export class QuoteItemPointsListConfigurationSerializerService
  implements
    IDataSerializer<
      IQuoteItemPointsListConfiguration,
      IQuoteItemPointsListConfiguration
    >
{
  serialize(
    item: IQuoteItemPointsListConfiguration,
  ): IQuoteItemPointsListConfiguration {
    return item;
  }
}
